// extracted by mini-css-extract-plugin
module.exports = {"headline":"AvailablePayments_headline__KLJBO","paymentProviderList":"AvailablePayments_paymentProviderList__hU3ZC"};